module.exports = __webpack_public_path__ + "static/media/ecommerce.d80aa94b.png";